import { render, staticRenderFns } from "./shuibqy.vue?vue&type=template&id=df54b686&scoped=true&"
import script from "./shuibqy.vue?vue&type=script&lang=js&"
export * from "./shuibqy.vue?vue&type=script&lang=js&"
import style0 from "./shuibqy.vue?vue&type=style&index=0&id=df54b686&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df54b686",
  null
  
)

export default component.exports